export default "__VITE_ASSET__BOWPOku8__"